import { render, staticRenderFns } from "./FerrySelect.vue?vue&type=template&id=4e642916&"
import script from "./FerrySelect.vue?vue&type=script&lang=js&"
export * from "./FerrySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports